import { activeGlobalWindowsVar } from '../models/GlobalChatConversations'

export const updateActiveGlobalWindows = (
  globalWindows: Array<string>
): Array<string> => {
  return activeGlobalWindowsVar(globalWindows)
}
